export const formatFileSize = (size) => {
  let formattedSize = `${size} b`;
  if (size > 1024) formattedSize = `${Math.round(size / 1024)} kb`;
  if (size > 1024 * 1024) {
    formattedSize = `${Math.round(size / 1024 / 1024)} Mb`;
  }

  return formattedSize;
};
